import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n";
import { apiErr } from "../lib/api";
import { AuthShell, Field } from "./Login";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Bienvenue sur AURORA TRADER AI");
      nav("/");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title={t("register")}>
      <form onSubmit={submit} className="space-y-4">
        <Field label={t("name")} type="text" value={name} onChange={setName} testid="register-name" />
        <Field label={t("email")} type="email" value={email} onChange={setEmail} testid="register-email" />
        <Field label={t("password")} type="password" value={password} onChange={setPassword} testid="register-password" />
        <button type="submit" disabled={busy} data-testid="register-submit"
          className="w-full bg-[#FACC15] text-[#05050A] font-semibold py-2.5 text-sm hover:bg-[#eab308] transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("signUp")}
        </button>
      </form>
      <p className="mt-6 text-center text-xs text-[#6B7280]">
        {t("haveAccount")}{" "}
        <Link to="/login" className="text-[#FACC15] hover:underline" data-testid="go-login">{t("signIn")}</Link>
      </p>
    </AuthShell>
  );
}
